import { Box, Divider, Flex, Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Table, Tbody, Td, Text, Tfoot, Th, Thead, Tr } from "@chakra-ui/react";
import { FiMoreVertical } from 'react-icons/fi';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';

import { useAuth } from "../../../hooks/auth";
import { ClienteDTO } from "../../../dtos/ClienteDTO";

type SortData = {
	por: string;
	cres: boolean;
};
type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};

interface DTTableParams {
	clientes: ClienteDTO[];
	pesqClientes: ClienteDTO[];
	sort: SortData;
	setSort: (sort: SortData) => void;
	controls: ControlsData;
	handleUpdateList: (page: number, perPage: number, finans: ClienteDTO[]) => void;
	setModalAddEditClienteVisible: (param: boolean) => void;
	setIdClienteModal: (param: string) => void;
};

const DTTable: React.FC<DTTableParams> = ({
	clientes,
	pesqClientes,
	sort,
	setSort,
	controls,
	handleUpdateList,
	setModalAddEditClienteVisible,
	setIdClienteModal
}) => {
	const { permissions } = useAuth();

	function handleSort(prop: string) {
		let mapped: ClienteDTO[] = [];

		const auxCres = !sort.cres;

		if (sort.por === prop) {
			if (auxCres) {
				mapped = pesqClientes.sort((a, b) => {
					return (
						+(Object(a)[prop] > Object(b)[prop]) ||
						+(Object(a)[prop] === Object(b)[prop]) - 1
					);
				});
			} else {
				mapped = pesqClientes.sort((a, b) => {
					return (
						+(Object(a)[prop] < Object(b)[prop]) ||
						+(Object(a)[prop] === Object(b)[prop]) - 1
					);
				});
			}
			setSort({ ...sort, cres: auxCres });
		} else {
			mapped = pesqClientes.sort((a, b) => {
				return (
					+(Object(a)[prop] > Object(b)[prop]) ||
					+(Object(a)[prop] === Object(b)[prop]) - 1
				);
			});
			setSort({ por: prop, cres: true });
		}

		// setSort({ por: prop, cres: !sort.cres });

		handleUpdateList(1, controls.perPage, mapped);
	};

	return (
		<Table colorScheme="blackAlpha" size="sm" whiteSpace="nowrap">
			<Thead>
				<Tr>
					<Th cursor="pointer" onClick={() => handleSort('nome')}>
						<Flex align="center">
							Nome
							{sort.por === 'nome' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'nome' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('doc')}>
						<Flex align="center">
							N. Doc.
							{sort.por === 'doc' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'doc' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('phone')}>
						<Flex justifyContent="flex-start">
							Telefone
							{sort.por === 'phone' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'phone' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('cid')}>
						<Flex>
							Cidade
							{sort.por === 'cid' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'cid' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					{(permissions.incluir || permissions.alterar) && (
						<Th></Th>
					)}
				</Tr>
			</Thead>

			<Tbody>
				{clientes.map(cliente => {
					return (
						<Tr
							key={cliente.id}
							fontSize={14}
							fontWeight={500}
							cursor="pointer"
						>
							<Td py="2" cursor="pointer">
								<Box>
									<Text color="blue.500" fontSize={15}>
										{cliente.nome === "" ? "--" : cliente.nome}
									</Text>
									<Text color="gray.500" fontSize={10}>
										{cliente.id}
									</Text>
								</Box>
							</Td>

							<Td py="2" cursor="pointer">
								<Box>
									<Text color="gray.500">
										{!cliente.doc ? "--" : cliente.doc}
									</Text>
								</Box>
							</Td>

							<Td py="2" color="gray.500">
								{!cliente.phone ? "--" : cliente.phone}
							</Td>

							<Td py="2" color="gray.500">
								{!cliente.cid ? "--" : cliente.cid}
							</Td>

							{(permissions.alterar || permissions.alterar) && (
								<Td>
									<Menu>
										{({ isOpen }) => (
											<>
												<MenuButton
													border={0}
													fontSize="1.5626rem"
													as={IconButton}
													isActive={isOpen}
													aria-label="Options"
													icon={<FiMoreVertical />}
													variant="outline"
													_hover={{ bg: 'gray.50' }}
												/>

												<MenuList p={0} boxShadow='xl'>
													<MenuItem
														fontSize={16}
														fontWeight={500}
														py={3}
														_hover={{ bg: 'gray.50' }}
														isDisabled
													>
														Detalhes
													</MenuItem>

													{permissions.alterar && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																onClick={() => {
																	setIdClienteModal(cliente.id);
																	setModalAddEditClienteVisible(true);
																}}
															>
																Editar
															</MenuItem>
														</>
													)}

													{permissions.excluir && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																isDisabled
																/* isDisabled={
																	(lancamento.fin_json.baixas && lancamento.fin_json.baixas.length > 0) ||
																	(lancamento.fin_json.documentos && lancamento.fin_json.documentos.length > 0)
																} */
															>
																Excluir
															</MenuItem>
														</>
													)}
												</MenuList>
											</>
										)}
									</Menu>
								</Td>
							)}
						</Tr>
					);
				})}
			</Tbody>

			<Tfoot>
				<Tr>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
				</Tr>
			</Tfoot>
		</Table>
	);
};

export default DTTable;